window.addEventListener('DOMContentLoaded', () => {
    const enquiryButtons = document.querySelectorAll('#page .header-text .custom-form + .wp-block-buttons a'),
          downloadBrochure = document.querySelectorAll('.download-brochure > a'),
          polymersEnquiryButtons = document.querySelectorAll('.polymers-amp-packaging .enquiry-button a');
          industrialEnquiryButtons = document.querySelectorAll('.construction--industrial-materials .enquiry-button a');

    if (enquiryButtons.length > 0 && (polymersEnquiryButtons.length === 0 && industrialEnquiryButtons.length === 0)) {
        enquiryButtons.forEach(enquiry => {
            enquiry.addEventListener('click', () => {
                enquiry.classList.toggle('active');
                let customForm = enquiry.parentElement.parentElement.previousElementSibling;
                customForm.classList.toggle('active');
                customForm.addEventListener('submit', () => {
                    setTimeout(() => {
                        enquiry.classList.remove('active');
                        customForm.classList.remove('active');
                    }, 1000);
                })
            }) 
        });

        downloadBrochure.forEach(btn => {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });

                let openFormBtn = document.querySelector('.button-download-brochure');
                    openFormBtn.querySelector('.wp-element-button').click();
            })
        })
    }

    const multipleEnquiry = (buttons, customFormSelector) => {
        const customForm = customFormSelector;

        const toggleActive = () => {
            buttons.forEach(btn => {
                btn.classList.toggle('active');
            })
        }

        buttons.forEach(enquiry => {
            enquiry.addEventListener('click', (event) => {
                toggleActive();
                if (enquiry.closest('.enquiry-button').classList.contains('additional') && 
                    !customForm.classList.contains('active')) {
                    event.preventDefault();
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
                customForm.classList.toggle('active');
                customForm.addEventListener('submit', () => {
                    setTimeout(() => {
                        toggleActive();
                        customForm.classList.remove('active');
                    }, 1000);
                })
            })
        })
    }

    if (polymersEnquiryButtons) {
        multipleEnquiry(polymersEnquiryButtons, document.querySelector('.polymers-amp-packaging .custom-form'));
    }

    if (industrialEnquiryButtons) {
        multipleEnquiry(industrialEnquiryButtons, document.querySelector('.construction--industrial-materials .custom-form'));
    }
})